import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';

import '../../Assets/css/kebabMenu.css';
import { disciplineStyles } from "../../Assets/js/customStyles.js";


export default function InternalMarkVerification() {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/college/");
    }

    const tableRef = useRef(null);

    const [disciplineId, setDisciplineChange] = useState(sessionStorage.getItem("discipline_id") ? sessionStorage.getItem("discipline_id") : null);
    const [disciplinetype, setDisciplineTypeChange] = useState(sessionStorage.getItem("discipline_type") ? sessionStorage.getItem("discipline_type") : null);
    const [examid, setExamIdData] = useState(sessionStorage.getItem("eaxm_id") ? sessionStorage.getItem("eaxm_id") : null);
    const [flag, setflag] = useState(false);
    const [disciplinedata, setDisciplineData] = useState([]);

    const [loading, setlodaing] = useState(false);

    const [getexamData, setExamData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showrevertModal, setShowRevertModal] = useState(false);
    const [courseNameData, setCourseNameData] = useState([]);
    const [courseData, setCourseData] = useState([]);
    const [loadingCourses, setLoadingCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null); // Track the selected course

    const { http } = Api();
    let cid = localStorage.getItem("collegeid");

    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const [selectedRevertCourse, setSelectedRevertCourse] = useState(null);

    const [showCourseModal, setCourseModal] = useState(false);
    const [registrationcount, setRegistrationcount] = useState({});
    const [apaarNo, setApaarNum] = useState([]);

    const handlExamChange = (selectedOption) => {
        // Clear the discipline data and table data when exam changes
        setDisciplineData([]);
        setCourseNameData([]);
        setCourseData([]);
        setRegistrationcount({}); // Reset registration count      

        setExamIdData(selectedOption.value);
        fetchDisciplineData(selectedOption.value); // Trigger the API call
    };

    useEffect(() => {
        const fetchExamData = async () => {
            try {
                const response = await http.get(`College/getPracticalExams`);
                // console.log("response", response.data);
                setExamData(response.data);
            }
            catch (error) {
                if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error("No active exam found");
                }
                else {
                    toast.error(error.response.data.message);
                }
            }
        };

        fetchExamData();
    }, []);

    // Function to fetch discipline data based on selected exam ID
    const fetchDisciplineData = async (selectedExamId) => {
        try {
            const response = await http.get(`College/getCollegeDisciplinesForPractical`, {
                params: {
                    examid: selectedExamId
                },
            });

            if (response.data.status_code === 'ERR5') {
                setflag(true);
            }
            setDisciplineData(response.data);
        } catch (error) {
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);
            } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response.data.message);
            }
        }
    };
    const fetchCourses = async (disciplineId, collegeCourseType) => {
        try {
            // API call to fetch courses based on selected discipline

            // console.log("disciplineId",disciplineId);
            // console.log("collegeCourseType",collegeCourseType);
            // console.log("examid",examid);
            const response = await http.get(`College/getCollegeDisciplineCoursesForPractical`, {
                params: {
                    discipline_id: disciplineId,
                    college_course_type: collegeCourseType,
                    examid: examid
                },
            });

            if (response.data.status_code === 'ERR5') {
                toast.error("No courses found for the selected discipline");
            } else {
                setCourseNameData(response.data); // Assuming response.data contains the list of courses
            }
        } catch (error) {
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);
            } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response.data.message);
            }
        }
    };



    // Calculate the maximum number of COs across all courses
    const maxCOs = Math.max(...courseData.map(course => course.maxMarks.no_of_co));

    const handlDisciplineChange = async (selectedOption) => {
        setCourseNameData([]); // Clear the course data initially
        setCourseData([]);
        setSelectedCourse(null);
        setRegistrationcount({}); // Reset registration count

        setDisciplineChange(selectedOption.did);
        setDisciplineTypeChange(selectedOption.type); // Update the discipline type
        // Fetch courses for the selected discipline
        fetchCourses(selectedOption.did, selectedOption.type);
    };

    const fetchStudentList = async (disciplineId, collegeCourseType, examId, courseId, course_group_id) => {
        // console.log("disciplineId",disciplineId);
        // console.log("collegeCourseType",collegeCourseType);
        // console.log("examId",examId);
        // console.log("courseId",courseId);
        // console.log("course_group_id",course_group_id);
        try {
            const response = await http.get(`College/getStudentListForPractical`, {
                params: {
                    discipline_id: disciplineId,
                    college_course_type: collegeCourseType,
                    examid: examId,
                    course_id: courseId,
                    course_group_id: course_group_id, // Static value as per your requirement
                },
            });

            if (response.data.status_code === 'ERR5') {
                toast.error("No students found for the selected course");
            } else {
                // Handle student data if required (e.g., set state or update UI)
                console.log("response=", response.data); // Replace this with your logic
                setCourseData(response.data);
                // Check if selectedCourse and other dependencies are valid


            }
        } catch (error) {
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);
            } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response.data.message);
            }
        }
    };

    useEffect(() => {
        if (selectedCourse) {
            GetRegistrationcount(); // Trigger Registrationcount only after selectedCourseId changes
        }
    }, [selectedCourse]); // Dependency on selectedCourseId

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),
        /* Additional custom scrollbar styling for WebKit-based browsers */
        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };
    const handleApproveAll = async () => {
        if (selectedStudents.length === 0 || !selectedCourse) {
            toast.error("No students or course selected");
            return;
        }

        // Filter selected students from courseData based on 'deo_forwarded' status
        const studentsToApprove = courseData
            .filter(course => course.verificationStatus === 'deo_forwarded' && selectedStudents.includes(course.accountid))
            .map(course => course.accountid); // Map to only include accountids of selected students

        if (studentsToApprove.length === 0) {
            toast.error("No students with 'deo_forwarded' status selected");
            return;
        }

        try {
            const response = await http.post(`College/PracticalMarkApproval`, {
                courseid: selectedCourse.value.split('-')[0], // Pass the selected course ID
                accountid: studentsToApprove,  // Pass only students with 'deo_forwarded' status
                examid: examid
            });

            if (response.data.http_status === 200) {
                toast.success(response.data.message);

                // After successful approval, re-fetch the student list for the selected course
                fetchStudentList(
                    disciplineId,
                    selectedCourse.collegeCourseType, // Passing the selected course type
                    examid,
                    selectedCourse.value.split('-')[0], // Pass the selected course ID
                    selectedCourse.courseGroupId // Pass the course group ID
                );
                setSelectedStudents([]); // Clear selection
                setSelectAll(false); // Reset "Select All"
                setShowModal(false); // Close modal                

            }
        } catch (error) {
            if (error.response?.data?.http_status === 500 || error.response?.data?.status_code === "ERR5") {
                toast.error(error.response.data.message);
            } else if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);
            } else {
                toast.error(error.response.data.message);
            }
        }
    };

    const handleCloseModal = () => {
        setShowModal(false); // Close the modal       

    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedStudents([]);
        } else {
            setSelectedStudents(courseData
                .filter(course => course.verificationStatus === 'deo_forwarded')
                .map(course => course.accountid));
        }
        setSelectAll(!selectAll);
    };

    const handleStudentSelect = (accountid) => {
        setSelectedStudents(prevSelected =>
            prevSelected.includes(accountid)
                ? prevSelected.filter(id => id !== accountid) // Deselect
                : [...prevSelected, accountid] // Select
        );
    };


    const handleOpenRevertModal = (course,apaarno) => {
        setSelectedRevertCourse(course);
        setSelectedStudents([]);
        setSelectAll(false);
        
        setApaarNum(apaarno);
        setShowRevertModal(true);
    };

    const handleCloseRevertModal = () => {
        setShowRevertModal(false);
        setSelectedRevertCourse(null);
    };

    const handleConfirmRevert = async () => {
        if (!selectedRevertCourse) return;

        const params = {
            accountid: selectedRevertCourse.accountid,
            examid: examid,
            courseid: selectedCourse.value.split('-')[0],
        };

        try {
            const response = await http.post('College/PracticalMarkRevert', params);

            if (response.data.http_status === 200) {
                toast.success(response.data.message);
                // Refresh course data after successful API call
                fetchStudentList(
                    disciplineId,
                    selectedCourse.collegeCourseType, // Passing the selected course type
                    examid,
                    selectedCourse.value.split('-')[0], // Pass the selected course ID
                    selectedCourse.courseGroupId // Pass the course group ID
                );
            } else {
                toast.error(response.data.message || "Revert failed!");
            }
        } catch (error) {
            if (error.response?.data?.http_status === 500 || error.response?.data?.status_code === "ERR5") {
                toast.error(error.response.data.message);
            } else if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);
            } else {
                toast.error(error.response.data.message);
            }
        } finally {
            handleCloseRevertModal();
        }
    };

    const handleOpenApproveModal = (accountid, verstatus,apaarno) => {

        if (verstatus !== 'deo_forwarded') {
            toast.error("Student is not in 'deo_forwarded' status");
            return; // Prevent opening modal for invalid status
        }
        setSelectedStudents([]);
        setSelectAll(false);
        handleStudentSelect(accountid); // Select the student
        setApaarNum(apaarno); 
        setShowModal(true); // Open modal
    };


    // Close the modal
    const handleCloseCourseModal = () => {
        setCourseModal(false);
    };


    const GetRegistrationcount = async () => {
        try {
            const response = await http.get(`College/getStudentStatForPractical`, {
                params: {
                    examid: examid,
                    discipline_id: disciplineId,
                    course_group_id: selectedCourse.courseGroupId, // Use the passed courseId or the current state
                    college_course_type: disciplinetype, // Replace with actual type
                    courseid: selectedCourse.value.split('-')[0]
                }
            });
            console.log(response.data);
            setRegistrationcount(response.data[0]);
        }
        catch (error) {
            if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);

            }
        }
    }

    const [openKebabCourseId, setOpenKebabCourseId] = useState(null);

    // Function to toggle the kebab menu for a specific row
    const toggleKebabMenu = (userId) => {
        // Toggle the open state for the specified course ID
        setOpenKebabCourseId(prevCourseId => (prevCourseId === userId ? null : userId));
    };


    // Close kebab menu when clicking anywhere on the screen -- 20/3/2024
    useEffect(() => {
        function handleClickOutside(event) {
            // Check if any kebab menu is open
            const isOpen = openKebabCourseId !== null;

            // Check if click is outside kebab menu and any kebab menu is open
            if (isOpen && !event.target.closest('.kebab-menu')) {
                // Close the open kebab menu
                setOpenKebabCourseId(null);
            }
        }

        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        };
    }, [openKebabCourseId]);


    const handleGeneratePDF = async (
        disciplineId,
        courseId,
        examid,
        collegeCourseType,
        courseGroupId,
        label


    ) => {
        // setLoading(true);
        try {
            const response = await http.get('/College/generatepracticalmarkstatment', {
                params: {
                    discipline_id: disciplineId,
                    courseid: courseId,
                    examid: examid,
                    college_course_type: collegeCourseType,
                    course_group_id: courseGroupId,
                },
                responseType: 'blob', // Expect binary response
            });

            if (response && response.data) {
                // Create a URL for the downloaded file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Set the file name and download the PDF
                link.setAttribute(
                    'download',
                    `${localStorage.getItem('username')}_${label}_${collegeCourseType}.pdf`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // setLoading(false);
                toast.success('PDF generated successfully');
            }
        } catch (error) {
            //console.log("error",error);
            // setLoading(false);
            if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);

            }
            else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
                toast.error(error.response.data.message);
            }
            else {
                console.error('Error generating PDF:', error);
                toast.error('Error generating PDF');
            }
        }
    };

    return (
        <>
            <ToastContainer />
            <Template>

                {loading ? (


                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (


                    <div className="container-fluid" >
                        <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className="modal-toggle-wrapper">
                                            <h4 className="text-center pb-2">Are you sure you want to forward?</h4>


                                            <p className="txt-aln">{apaarNo && apaarNo.length > 0 && selectedStudents.length === 1 ? `APAAR No:- ${apaarNo}`  : null }</p>
                                            <div className="d-flex justify-content-center mt-3">
                                                
                                                <button className="btn btn-success mx-2" onClick={handleApproveAll}>Yes</button>
                                                <button
                                                    className="btn"
                                                    style={{
                                                        backgroundColor: 'white',
                                                        borderColor: 'green',
                                                        color: 'black',
                                                    }}
                                                    onClick={handleCloseModal}
                                                >
                                                    No
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className={`modal fade show ${showrevertModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className="modal-toggle-wrapper">
                                            <h4 className="text-center pb-2">Are you sure you want to revert?</h4>
                                            <p className="txt-aln">{apaarNo ? `APAAR No:- ${apaarNo}`  : null }</p>

                                            <div className="d-flex justify-content-center mt-3">
                                                <button className="btn btn-danger mx-2" onClick={handleConfirmRevert}>Yes</button>
                                                <button
                                                    className="btn"
                                                    style={{
                                                        backgroundColor: 'white',
                                                        borderColor: 'red',
                                                        color: 'black',
                                                    }}
                                                    onClick={handleCloseRevertModal}
                                                >
                                                    No
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`modal fade show ${showCourseModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className="modal-toggle-wrapper">
                                            <h4 className="text-center pb-2">CO Mapping Not Completed</h4>
                                            <div className="d-flex justify-content-center mt-3">

                                                <button
                                                    className="btn"
                                                    style={{
                                                        backgroundColor: 'white',
                                                        borderColor: 'red',
                                                        color: 'black',
                                                    }}
                                                    onClick={handleCloseCourseModal}
                                                >
                                                    OK
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center ">
                                                <h5>Practical ESE Mark Entry</h5>
                                            </div>

                                        </div>
                                        <div className="card-body">

                                            <div className="card-body pdg">
                                                <div className="table-responsive">

                                                    <div className="form theme-form">
                                                        <div className="card-body custom-input">


                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <label>Examination <span className="errorclr">*</span></label>

                                                                    <Select
                                                                        styles={customStyles}
                                                                        maxMenuHeight={200}
                                                                        menuPlacement="auto"
                                                                        id="exam_id"
                                                                        name="exam_id"
                                                                        className="basic-select"
                                                                        classNamePrefix="select"
                                                                        options={getexamData.map(exam => ({
                                                                            value: exam.examid,
                                                                            label: exam.examtitle
                                                                        }))}
                                                                        onChange={handlExamChange}
                                                                        placeholder="Select an exam..."

                                                                        value={getexamData
                                                                            .filter(exam => exam.examid.toString() === examid ? examid.toString() : '')
                                                                            .map(exam => ({
                                                                                value: exam.examid,
                                                                                label: exam.examtitle
                                                                            }))[0]}
                                                                    />
                                                                </div>


                                                                <div className="col-md-4">
                                                                    <label>Discipline<span className="errorclr">*</span></label>

                                                                    <Select
                                                                        styles={disciplineStyles}

                                                                        maxMenuHeight={500}
                                                                        menuPlacement="auto"
                                                                        id="discipline_id"
                                                                        name="discipline_id"
                                                                        className="form"
                                                                        onChange={handlDisciplineChange}
                                                                        options={Array.isArray(disciplinedata) && disciplinedata.length > 0
                                                                            ? disciplinedata
                                                                                .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                                                                .map(discipline => ({
                                                                                    did: discipline.id,
                                                                                    value: discipline.discipline_name,
                                                                                    label: discipline.discipline_name,
                                                                                    type: discipline.college_course_type
                                                                                }))
                                                                            : [{ value: '0', label: 'No data found' }]
                                                                        }
                                                                        value={disciplinedata && Array.isArray(disciplinedata)
                                                                            ? disciplinedata
                                                                                .filter(discipline =>
                                                                                    discipline.id.toString() === disciplineId &&
                                                                                    discipline.college_course_type === disciplinetype // Added filter for discipline_type
                                                                                )
                                                                                .map(discipline => ({
                                                                                    value: discipline.discipline_name,
                                                                                    label: discipline.discipline_name,
                                                                                }))[0]
                                                                            : null}

                                                                        placeholder="Select Discipline"
                                                                    />

                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label>Course<span className="errorclr">*</span></label>

                                                                    <Select
                                                                        styles={customStyles}
                                                                        maxMenuHeight={500}
                                                                        menuPlacement="auto"
                                                                        id="course_id"
                                                                        name="course_id"
                                                                        className="form"
                                                                        options={courseNameData.length > 0
                                                                            ? courseNameData.map(course => ({
                                                                                value: `${course.courseid}-${course.course_group_id}`,
                                                                                label: course.course_name,
                                                                                collegeCourseType: course.college_course_type,
                                                                                courseGroupId: course.course_group_id,
                                                                                mappingFlag: course.mapping_flag,
                                                                            }))
                                                                            : [{ value: '', label: 'No courses available' }]
                                                                        }
                                                                        placeholder="Select Course"
                                                                        value={selectedCourse}
                                                                        onChange={(selectedOption) => {

                                                                            setSelectedCourse(selectedOption);
                                                                            setCourseData([]);
                                                                            setRegistrationcount({}); // Reset registration count

                                                                            if (selectedOption.mappingFlag != null) {
                                                                                setCourseModal(true);
                                                                            }
                                                                            else {
                                                                                fetchStudentList(
                                                                                    disciplineId,
                                                                                    selectedOption.collegeCourseType,
                                                                                    examid,
                                                                                    selectedOption.value.split('-')[0],
                                                                                    selectedOption.courseGroupId
                                                                                ); // Pass parameters to the API
                                                                            }
                                                                        }}
                                                                    />



                                                                </div>



                                                            </div>

                                                            {/* count display section */}

                                                            {Object.keys(registrationcount).length > 0 && (
                                                                <>
                                                                    <div className="row">
                                                                        <table className="table table-striped  table-bordered ex-table mb-10" ref={tableRef} id="dataTable">
                                                                            <thead class="table-primary">
                                                                                <tr className="col-cnt-tab-bg-clr">

                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }} rowSpan={2}>Course</th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }} rowSpan={2}>Total Registered Students </th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }} colSpan={3}>Attendance</th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }} colSpan={5}>Mark Entry</th>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={{ textAlign: "center", verticalAlign: "middle" }}>P</th>
                                                                                    <th style={{ textAlign: "center", verticalAlign: "middle" }}>A</th>
                                                                                    <th style={{ textAlign: "center", verticalAlign: "middle" }}>M</th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }}>DEO Not Entered</th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }}>DEO Entered</th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }}>DEO Forwarded</th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }}>Principal Reverted</th>
                                                                                    <th scope="col" width="" style={{ textAlign: "center", verticalAlign: "middle" }}>Forwarded to University</th>
                                                                                    {/* <th scope="col" width="" rowSpan={2}>Pending DEO Verification </th>
                                                                                    <th scope="col" width="" rowSpan={2}>Pending Approval</th> */}
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                <tr style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                    <td>{registrationcount.course_code ? registrationcount.course_code + '-' + registrationcount.course_name + '-' + registrationcount.group_name : "--"}</td>
                                                                                    <td>{registrationcount.total_students ? registrationcount.total_students : "0"}</td>
                                                                                    <td>{registrationcount.present_count ? registrationcount.present_count : "0"}</td>
                                                                                    <td>{registrationcount.absent_count ? registrationcount.absent_count : "0"}</td>
                                                                                    <td>{registrationcount.malpractice_count ? registrationcount.malpractice_count : "0"}</td>



                                                                                    <td>{registrationcount.DEO_Not_Entered ? registrationcount.DEO_Not_Entered : "0"}</td>
                                                                                    <td>{registrationcount.DEO_entered ? registrationcount.DEO_entered : "0"}</td>
                                                                                    <td>{registrationcount.DEO_forwarded ? registrationcount.DEO_forwarded : "0"}</td>
                                                                                    <td>{registrationcount.Principal_reverted ? registrationcount.Principal_reverted : "0"}</td>
                                                                                    <td>{registrationcount.Principal_forwarded ? registrationcount.Principal_forwarded : "0"}</td>
                                                                                    {/* <td>{registrationcount.DEO_Verification_Pending ? registrationcount.DEO_Verification_Pending : "0"}</td>
                                                                                    <td>{registrationcount.pending_count ? registrationcount.pending_count : "0"}</td> */}



                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </>)}



                                                            {courseData.length > 0 && (<div className="buttons-container m-t-10 nav-right">

                                                                <button
                                                                    className="lbl2 btn btn-primary mt-3"
                                                                    onClick={() => handleGeneratePDF(
                                                                        disciplineId,
                                                                        selectedCourse.value.split('-')[0], // Extract courseid
                                                                        examid,
                                                                        selectedCourse.collegeCourseType,
                                                                        selectedCourse.courseGroupId,
                                                                        selectedCourse.label,
                                                                        selectedCourse.collegeCourseType,
                                                                    )}
                                                                    title="Download"
                                                                >
                                                                    <i class="bi bi-arrow-down-square"></i>
                                                                </button>


                                                            </div>)}

                                                            <div className="table-container mt-5 " style={{ minHeight: '500px' }}>
                                                                {selectedStudents.length > 0 && (
                                                                    <>

                                                                        <div className="d-flex  justify-content-end">
                                                                            <button
                                                                                className="btn btn-success btn-sm mt-2"
                                                                                onClick={() => setShowModal(true)}
                                                                                style={{ width: "auto" }}
                                                                            >

                                                                                <span >Forward</span> <span><sup className='badge bg-danger-subtle' style={{ fontSize: '9px', color: 'red', fontWeight: 'bold', textAlign: "center" }}>{selectedStudents.length}</sup></span>
                                                                            </button>
                                                                        </div>

                                                                    </>
                                                                )}
                                                                <table className="table table-bordered mt-3 border" >

                                                                    {courseData.length > 0 ? (
                                                                        <thead>
                                                                            <tr style={{ height: '2.5rem' }}>
                                                                                <th style={{ width: '40px', textAlign: 'center' }} className="bg-primary ">
                                                                                    {
                                                                                        // Show checkbox if any course.verificationStatus is 'deo_forwarded'
                                                                                        courseData.some(course => course.verificationStatus === 'deo_forwarded') && (
                                                                                            <>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={selectAll}
                                                                                                    onChange={handleSelectAll}
                                                                                                />


                                                                                            </>
                                                                                        )
                                                                                    }

                                                                                </th>
                                                                                <th style={{ textAlign: "center", verticalAlign: "middle" }} className="bg-primary ">
                                                                                <div className="col-ft">Sl No</div>

                                                                                    {courseData[0].maxMarks.practical && (
                                                                                        <> Practical ESE (Max. Mark): {courseData[0].maxMarks.practical}</>
                                                                                    )}

                                                                                </th>

                                                                                <th className="bg-primary">


                                                                                </th>

                                                                            </tr>
                                                                        </thead>
                                                                    ) : null}
                                                                    <tbody>
                                                                        {courseData.length > 0 ? (
                                                                            courseData.map((course, courseIndex) => (
                                                                                <React.Fragment key={courseIndex}>

                                                                                    <tr>
                                                                                        <td style={{ backgroundColor: 'rgb(88, 31, 55)', color: '#FFF', textAlign: 'center' }}>

                                                                                            {course.verificationStatus === 'deo_forwarded' && (
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={selectedStudents.includes(course.accountid)}
                                                                                                    onChange={() => handleStudentSelect(course.accountid)}
                                                                                                />
                                                                                            )}
                                                                                        </td>
                                                                                       
                                                                                        
                                                                                        <td style={{ backgroundColor: 'rgb(88, 31, 55)', color: '#FFF', textAlign: "center", verticalAlign: "middle" }}>

                                                                                            <div className="col-ft">{courseIndex + 1}</div>
                                                                                            <div className="d-flex align-items-center justify-content-center">
                                                                                                {/* <span className="me-2">{courseIndex + 1}).</span> */}
                                                                                                <span className="me-2">{course.PRN}-</span>
                                                                                                <span className="fw-bold">{course.studentName}</span>
                                                                                                <span className="ms-2">({course.APAAR})</span>




                                                                                            </div>



                                                                                        </td>

                                                                                        <td style={{ textAlign: "center", backgroundColor: 'rgb(88, 31, 55)', color: '#FFF' }}>
                                                                                            Action
                                                                                        </td>

                                                                                    </tr>


                                                                                    <tr>
                                                                                        <td className='mt-2' style={{ textAlign: 'center', verticalAlign: 'middle', }}>
                                                                                            {course.ATTENDANCE === 'P' ? (
                                                                                                <span className="badge rounded-pill bg-success text-light">
                                                                                                    <i className="bi bi-person-check-fill me-1"></i> Present
                                                                                                </span>
                                                                                            ) : course.ATTENDANCE === 'A' ? (
                                                                                                <span className="badge rounded-pill bg-danger text-light">
                                                                                                    <i className="bi bi-person-x-fill me-1"></i> Absent
                                                                                                </span>
                                                                                            ) : null
                                                                                            }
                                                                                            <br />



                                                                                        </td>

                                                                                        <td className="p-l-60">


                                                                                            <div className=" d-flex justify-content-center align-items-center  bg-primary" >
                                                                                                <div
                                                                                                    className={`d-flex justify-content-center align-items-center py-1 px-3 ${course.verificationStatus === "deo_forwarded" ? "badge-info" :
                                                                                                        course.verificationStatus === "principal_forwarded"
                                                                                                            ? "badge-success"
                                                                                                            : course.verificationStatus === "principal_reverted"
                                                                                                                ? "badge-danger"
                                                                                                                : course.verificationStatus === null || course.verificationStatus === "entered"
                                                                                                                    ? "badge-warning"
                                                                                                                    : "badge-danger"
                                                                                                        }`}
                                                                                                >
                                                                                                    {course.displayStatus == null ? "--" : <><i className={`bi bi-${course.verificationStatus === null || course.verificationStatus === "entered" ? "clock" : course.verificationStatus === "deo_forwarded" ? "check-circle-fill" : course.verificationStatus === "principal_forwarded" ? "check-circle-fill" : "x-circle-fill"}`} style={{ marginRight: '5px' }}></i>{course.displayStatus}</>}
                                                                                                </div>

                                                                                            </div>
                                                                                            <table className="w-full border-collapse" style={{ width: '100%', fontSize: '0.8rem', border: '1px solid black', }} >
                                                                                                <thead className="bg-gray-100" style={{ fontSize: '0.8rem', border: '1px solid black', }}>

                                                                                                    <tr >
                                                                                                        <th style={{ fontSize: '0.8rem', border: '1px solid black', }}></th>
                                                                                                        {Array.from({ length: maxCOs }).map((_, coIndex) => (
                                                                                                            <th key={coIndex} className="text-center" style={{ fontSize: '0.8rem', border: '1px solid black', }}>
                                                                                                                <b>{coIndex < course.maxMarks.no_of_co ? `CO${coIndex + 1}` : " "}</b>
                                                                                                            </th>
                                                                                                        ))}
                                                                                                        <th className="text-center" style={{ fontSize: '0.8rem', border: '1px solid black', }}>
                                                                                                            <b> Total marks </b>
                                                                                                        </th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody style={{ fontSize: '0.8rem', border: '1px solid black', }}>
                                                                                                    <tr>
                                                                                                        <td className="border border-black px-2 py-1">
                                                                                                            {course.maxMarks.practical && <strong>Marks Obtained</strong>}
                                                                                                        </td>

                                                                                                        {Array.from({ length: maxCOs }).map((_, coIndex) => (
                                                                                                            <td key={coIndex} className="border border-black px-2 py-1 text-center">
                                                                                                                {coIndex < course.maxMarks.no_of_co && course.maxMarks.practical
                                                                                                                    ? course.practicalValues[coIndex]?.mesi_practical !== undefined
                                                                                                                        ? course.coValues.map((cos) =>
                                                                                                                            cos.co === course.practicalValues[coIndex].co &&
                                                                                                                                course.practicalValues[coIndex].mesi_practical
                                                                                                                                ? `${course.practicalValues[coIndex].mesi_practical} / ${course.practicalValues[coIndex].practical_co_max}`
                                                                                                                                : null
                                                                                                                        )
                                                                                                                        : "-"
                                                                                                                    : null}
                                                                                                            </td>
                                                                                                        ))}

                                                                                                        <td className="border border-black px-2 py-1 text-center" >
                                                                                                            {course.maxMarks.practical && course.total_marks_secured === '-' ? "-" :  <strong>{course.total_marks_secured}/{course.maxMarks.practical} </strong>}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>



                                                                                            </table>


                                                                                        </td>


                                                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                            {course.verificationStatus === 'deo_forwarded' ? (
                                                                                                <div className="kebab-menu">
                                                                                                    <button className="kebab-menu-button" onClick={() => toggleKebabMenu(course.accountid)}>
                                                                                                        &#8942;
                                                                                                    </button>
                                                                                                    {openKebabCourseId === course.accountid && (
                                                                                                        <div className="kebab-menu-items">

                                                                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                                                                                                                <button className='btn btn-success btn-sm' style={{ padding: '6px', height: '30px', marginBottom: '5px', width: '90%' }}
                                                                                                                    onClick={() => handleOpenApproveModal(course.accountid, course.verificationStatus ,course.APAAR)}>
                                                                                                                    <i
                                                                                                                        className="fa fa-check-circle"
                                                                                                                        style={{ color: "white" }}
                                                                                                                        aria-hidden="true"
                                                                                                                    ></i>&nbsp; Forward to university
                                                                                                                </button>
                                                                                                                <button className='btn btn-danger btn-sm' style={{ height: '30px', width: '90%' }} onClick={() => handleOpenRevertModal(course, course.APAAR)}>
                                                                                                                    <i
                                                                                                                        className="fa fa-undo"
                                                                                                                        style={{ color: "white" }}
                                                                                                                        aria-hidden="true"
                                                                                                                    ></i>&nbsp; Revert
                                                                                                                </button>
                                                                                                            </div>

                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div>

                                                                                                </div>
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>

                                                                                </React.Fragment>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    No Data Found
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>

                                                            </div>







                                                        </div>


                                                    </div>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )}


            </Template>
        </>
    );
}
